import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List, Drawer, ListHeading } from '@oliasoft-open-source/react-ui-library';
import { addInitialCompare, compareSelected } from 'store/entities/compare-estimates/compare-estimates';
import translations from 'src/internationalisation/translation-map.json';
import { selectCompanyNameById } from 'store/entities/companies/selectors';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

const CompareList = ({
  companyId,
  list,
  compareSelected,
  addInitialCompare,
  onClickDeleteCompare,
  onClickEditCompare,
  setEditItem,
  estimates,
  companyName,
}) => {
  const { t } = useTranslation();
  const buildItems = (list) =>
    list.map((compare) => {
      const compareDesignsCount = compare.designs?.length || 0;
      const estimatesCount = (estimates || []).filter((item) => item.compareId === compare.compareId).length;
      const itemsCount = compareDesignsCount || estimatesCount;
      return {
        testId: `compare-list-${convertToKebabCase(compare.name)}-item`,
        id: compare.compareId,
        name: compare.name,
        metadata: `${itemsCount}  ${'Items'} - ${compare.isPublic ? companyName : t(translations.projects_onlyMe)}`,
        active: compare.active,
        onClick: () => {
          compareSelected(compare.compareId);
          setEditItem(compare);
        },
        actions: [
          {
            label: t(translations.more),
            testId: `compare-list-${convertToKebabCase(compare.name)}-more-button`,
            subActions: [
              {
                label: t(translations.edit),
                testId: `compare-list-${convertToKebabCase(compare.name)}-edit-button`,
                icon: 'edit',
                onClick: () => onClickEditCompare(compare),
              },
              {
                label: t(translations.delete),
                testId: `compare-list-${convertToKebabCase(compare.name)}-delete-button`,
                icon: 'delete',
                onClick: () => onClickDeleteCompare(compare.compareId),
              },
            ],
          },
        ],
      };
    });

  const compareItems = buildItems(list);

  return (
    <Drawer border button closedWidth="100px" open width="320px">
      <div data-testid="compare-list-subheading">
        <ListHeading
          name={t(translations.compare)}
          actions={[
            {
              label: t(translations.add),
              primary: true,
              icon: 'add',
              onClick: () => addInitialCompare(companyId),
              testId: 'compare-list-subheading-add-button',
            },
          ]}
        />
      </div>
      <List noHeader testId="compare-list" list={{ items: compareItems }} />
    </Drawer>
  );
};

const mapStateToProps = ({ entities }, { companyId }) => {
  const {
    authorization: { withWelldesignLicense },
  } = entities;

  return {
    companyName: selectCompanyNameById(entities, companyId),
    withWelldesignLicense,
  };
};

const mapDispatchToProps = {
  compareSelected,
  addInitialCompare,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(CompareList), {
  style: { width: '320px' },
});

export { Container as CompareList };
